import React from 'react';
import * as C from "../componentsM/index";

const ParentCouncil = () => <>

    <C.Hero title={"PARENT COUNCIL"} image={"/hero/inside.jpg"} />


    <section className='p-4 md:p-24'>

        <h6 className='font-semibold mb-4'>Welcome to The International School Parent Council Webpage. The parent council members extend a cordial invitation to all parents of The International School to join us in sharing our vision and creating an exciting educational experience for all.</h6>

        <h6 className='font-semibold mb-4'>The purpose of the parent council is to represent the parent’s perspective on issues involving their child’s education. As parent council members we shall engage TIS parents for greater involvement in supporting the school to meet their extra-curricular needs and enhancing the IB programme. The <br /> <a className='text-myBlue/60' href="/parent-council/parent-councilparent-council-policy"> parent council policy</a> is an intrinsic part in making the council a success.</h6>

        <h6 className='font-semibold mb-4'>In order to foster a greater working relationship with the school head and staff it is essential for parents to communicate with each other  in building a vibrant TIS community. This will encompass physical involvement in activities of the school to promote, enhance and enrich the school so our children can have a more beneficial education.</h6>

        <h6 className='font-semibold mb-4'>Look out for our own <span className='underline'>newsletter</span> which will be published bi-annually.  We are a resource for any questions or concerns you may have. Please do not hesitate to communicate your ideas with us at <a className='text-myBlue/60' href="mailto:pc@tis.edu.pk.">  pc@tis.edu.pk.</a> </h6>

        <h6 className='font-semibold mb-4'>The names of the Parent Council members,</h6>


        <ul className='list-disc list-inside marker:bg-myBlue'>
            {[
                "Asma Sohail",
                "Bilal Moti",
                "Faiza Saghir",
                "Mahdi Ameer",
                "Rabia Azfa",
                "Rabya Saeed",
                "Shams Begum Uqaili",
                "Sophia Hasnain"
            ].map(v =>
                <li className='font-bold mb-2 ' key={v}>{v}</li>)}
        </ul>

    </section>
</>

export default ParentCouncil